// 工单静态数据（模拟真实现场巡检数据）

export const RISK_LEVELS = {
  high: {
    key: 'high',
    label: '高',
    badge: 'bg-red-50 text-red-600 ring-1 ring-red-200',
    dot: 'bg-red-500',
  },
  mid: {
    key: 'mid',
    label: '中',
    badge: 'bg-amber-50 text-amber-600 ring-1 ring-amber-200',
    dot: 'bg-amber-500',
  },
  low: {
    key: 'low',
    label: '低',
    badge: 'bg-emerald-50 text-emerald-600 ring-1 ring-emerald-200',
    dot: 'bg-emerald-500',
  },
};

export const workOrder = {
  code: 'WO-2026-0803-0271',
  title: '深圳光明数据中心 · 模组 M03 UPS 设备季度查验',
  status: '执行中',
  module: {
    name: '模组 M03',
    site: '深圳光明数据中心',
    building: '3 号楼 · 2F',
    powerZone: 'A 供电分区',
  },
  deviceType: {
    name: 'UPS 不间断电源',
    code: 'DEV-UPS',
    spec: '500kVA 模块化 / 三进三出',
    vendor: '维谛 Vertiv NXL',
    total: 24,
  },
  plan: {
    owner: '李海涛',
    ownerEng: 'haitaoli',
    team: '基础设施运维二组',
    planStart: '2026-08-03 09:00',
    planEnd: '2026-08-03 18:00',
    cycle: '季度巡检',
  },
};

export const checkItems = [
  {
    id: 'CK-01',
    category: '外观与环境',
    item: '机柜外观及标识完整性',
    standard: '柜体无变形、无锈蚀，铭牌/回路标识清晰可辨，柜门可正常闭锁',
    risk: 'low',
    method: '目视',
    ref: 'GB 50174-2017 6.2',
  },
  {
    id: 'CK-02',
    category: '外观与环境',
    item: '设备间环境温湿度',
    standard: '环境温度 18~27℃，相对湿度 40%~60%，无凝露',
    risk: 'mid',
    method: '仪表测量',
    ref: 'GB 50174-2017 5.1',
  },
  {
    id: 'CK-03',
    category: '电气参数',
    item: '输入三相电压与频率',
    standard: '相电压 220V±5%，线电压 380V±5%，频率 50Hz±0.5Hz，三相不平衡度 ≤5%',
    risk: 'high',
    method: '仪表测量',
    ref: 'DL/T 5218',
  },
  {
    id: 'CK-04',
    category: '电气参数',
    item: '输出电压与负载率',
    standard: '输出电压偏差 ≤±1%，单机负载率 ≤70%，双母线合计 ≤40%',
    risk: 'high',
    method: '监控读数',
    ref: '内控标准 IDC-UPS-03',
  },
  {
    id: 'CK-05',
    category: '电气参数',
    item: '旁路与静态开关状态',
    standard: '静态开关处于正常在线模式，旁路无异常投入记录',
    risk: 'high',
    method: '面板核查',
    ref: '内控标准 IDC-UPS-05',
  },
  {
    id: 'CK-06',
    category: '电池系统',
    item: '电池组端电压与内阻',
    standard: '单体电压 13.2~13.8V，内阻偏差不超出基准值 20%',
    risk: 'high',
    method: '内阻仪测量',
    ref: 'YD/T 5083',
  },
  {
    id: 'CK-07',
    category: '电池系统',
    item: '电池外观与极柱',
    standard: '无鼓包、渗液，极柱无氧化，连接条扭矩符合 12N·m',
    risk: 'mid',
    method: '目视 + 扭矩扳手',
    ref: 'YD/T 5083',
  },
  {
    id: 'CK-08',
    category: '电池系统',
    item: '后备时间校验',
    standard: '满载后备时间 ≥15min，放电测试记录在有效期内（≤12 个月）',
    risk: 'high',
    method: '记录核查',
    ref: '内控标准 IDC-BAT-02',
  },
  {
    id: 'CK-09',
    category: '散热与风道',
    item: '风机运行与滤网洁净度',
    standard: '风机无异响、无停转，滤网积尘厚度 ≤1mm，进出风无遮挡',
    risk: 'mid',
    method: '目视 + 听诊',
    ref: '厂商维护手册 4.3',
  },
  {
    id: 'CK-10',
    category: '散热与风道',
    item: '关键点位红外测温',
    standard: '接线端子温升 ≤40K，同类点位温差 ≤10℃，无局部过热',
    risk: 'high',
    method: '红外热像仪',
    ref: 'DL/T 664',
  },
  {
    id: 'CK-11',
    category: '告警与监控',
    item: '本地告警与历史事件',
    standard: '无未处理告警，历史事件已闭环并留存处理记录',
    risk: 'mid',
    method: '面板 + 后台核查',
    ref: '内控标准 IDC-ALM-01',
  },
  {
    id: 'CK-12',
    category: '告警与监控',
    item: '动环采集与上报链路',
    standard: '监控平台数据刷新延迟 ≤60s，关键点位采集无中断',
    risk: 'mid',
    method: '平台核对',
    ref: '内控标准 IDC-DCIM-02',
  },
  {
    id: 'CK-13',
    category: '接地与安全',
    item: '接地电阻与等电位连接',
    standard: '联合接地电阻 ≤1Ω，接地线截面与压接符合设计要求',
    risk: 'high',
    method: '接地电阻测试仪',
    ref: 'GB 50169',
  },
  {
    id: 'CK-14',
    category: '接地与安全',
    item: '消防联动与紧急停机',
    standard: 'EPO 回路完好并铅封，消防联动信号测试通过（每半年一次）',
    risk: 'high',
    method: '功能验证',
    ref: 'GB 50016',
  },
  {
    id: 'CK-15',
    category: '资料与标识',
    item: '巡检记录与固件版本',
    standard: '上次巡检记录齐全，固件版本与基线一致，变更有审批单',
    risk: 'low',
    method: '资料核查',
    ref: '内控标准 IDC-DOC-01',
  },
];

// 方仓 / 房间及其内部设备
export const rooms = [
  {
    id: 'RM-A01',
    name: '1 号方仓 · 电力室 A',
    pod: '1 号方仓',
    area: '128 ㎡',
    temp: '23.4 ℃',
    humidity: '48 %RH',
    devices: [
      { sn: 'UPS-M03-A01-01', model: 'NXL-500K', load: '38%' },
      { sn: 'UPS-M03-A01-02', model: 'NXL-500K', load: '41%' },
      { sn: 'UPS-M03-A01-03', model: 'NXL-500K', load: '35%' },
      { sn: 'UPS-M03-A01-04', model: 'NXL-500K', load: '39%' },
      { sn: 'UPS-M03-A01-05', model: 'NXL-500K', load: '44%' },
      { sn: 'UPS-M03-A01-06', model: 'NXL-500K', load: '0%' },
    ],
  },
  {
    id: 'RM-A02',
    name: '1 号方仓 · 电池室 A',
    pod: '1 号方仓',
    area: '96 ㎡',
    temp: '24.1 ℃',
    humidity: '45 %RH',
    devices: [
      { sn: 'BAT-M03-A02-01', model: '12V100Ah×40', load: '—' },
      { sn: 'BAT-M03-A02-02', model: '12V100Ah×40', load: '—' },
      { sn: 'BAT-M03-A02-03', model: '12V100Ah×40', load: '—' },
      { sn: 'BAT-M03-A02-04', model: '12V100Ah×40', load: '—' },
    ],
  },
  {
    id: 'RM-B01',
    name: '2 号方仓 · 电力室 B',
    pod: '2 号方仓',
    area: '128 ㎡',
    temp: '22.8 ℃',
    humidity: '51 %RH',
    devices: [
      { sn: 'UPS-M03-B01-01', model: 'NXL-500K', load: '52%' },
      { sn: 'UPS-M03-B01-02', model: 'NXL-500K', load: '49%' },
      { sn: 'UPS-M03-B01-03', model: 'NXL-500K', load: '55%' },
      { sn: 'UPS-M03-B01-04', model: 'NXL-500K', load: '47%' },
      { sn: 'UPS-M03-B01-05', model: 'NXL-500K', load: '50%' },
    ],
  },
  {
    id: 'RM-B02',
    name: '2 号方仓 · 配电室 B',
    pod: '2 号方仓',
    area: '84 ㎡',
    temp: '25.6 ℃',
    humidity: '43 %RH',
    devices: [
      { sn: 'PDC-M03-B02-01', model: 'ATS-1600A', load: '61%' },
      { sn: 'PDC-M03-B02-02', model: 'ATS-1600A', load: '58%' },
      { sn: 'PDC-M03-B02-03', model: 'ATS-1600A', load: '63%' },
    ],
  },
  {
    id: 'RM-C01',
    name: '3 号方仓 · 电力室 C',
    pod: '3 号方仓',
    area: '112 ㎡',
    temp: '23.0 ℃',
    humidity: '47 %RH',
    devices: [
      { sn: 'UPS-M03-C01-01', model: 'NXL-500K', load: '33%' },
      { sn: 'UPS-M03-C01-02', model: 'NXL-500K', load: '36%' },
      { sn: 'UPS-M03-C01-03', model: 'NXL-500K', load: '31%' },
    ],
  },
  {
    id: 'RM-C02',
    name: '3 号方仓 · 冷冻站',
    pod: '3 号方仓',
    area: '150 ㎡',
    temp: '26.2 ℃',
    humidity: '55 %RH',
    devices: [
      { sn: 'CHL-M03-C02-01', model: 'RTHD-450RT', load: '72%' },
      { sn: 'CHL-M03-C02-02', model: 'RTHD-450RT', load: '68%' },
      { sn: 'CHL-M03-C02-03', model: 'RTHD-450RT', load: '0%' },
    ],
  },
];

// 问题发现阶段（单选）
export const ISSUE_STAGES = ['验证测试', '交付接维'];

// 问题类型（单选）
export const ISSUE_TYPES = ['设备质量', '安装工艺', '设备调试', '规划设计', '其它'];

// 问题级别（单选）
export const SEVERITIES = [
  { key: 'high', label: '高' },
  { key: 'mid', label: '中' },
  { key: 'low', label: '低' },
];
